import { render, staticRenderFns } from "./PlatformFlow.vue?vue&type=template&id=4412e440&scoped=true"
import script from "./PlatformFlow.vue?vue&type=script&lang=js"
export * from "./PlatformFlow.vue?vue&type=script&lang=js"
import style0 from "./PlatformFlow.vue?vue&type=style&index=0&id=4412e440&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4412e440",
  null
  
)

export default component.exports